import { __read } from "tslib";
import { useCallback, useEffect, useState } from 'react';
/**
 * Use this hook to lazy load codes that is not part of critical path.
 * The lazy loaded code needs to be pure functions.
 * Make sure to handle null cases until the code is loaded.
 * @param importModule - An import of a module which needs to be lazy loaded.
 * @returns - returns the default and exported objects from the imported code.
 */
export function useLazyHook(importModule) {
    var _a = __read(useState(null), 2), actionResult = _a[0], setActionResult = _a[1];
    // arrow function is a new function everytime they are called and it causes constant rerenders.
    // useCallback with empty dependency array prevents rerenders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var importActionCallback = useCallback(importModule, []);
    useEffect(function () {
        importActionCallback().then(function (lazyHookAction) {
            return setActionResult(lazyHookAction);
        });
    }, [importActionCallback]);
    return actionResult;
}
//# sourceMappingURL=useLazyHook.js.map